module.exports = __webpack_public_path__ + "img/paxg.cf294e6a.svg";